// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ha","avatarImg":"hb"};